import React from 'react';
import { formatAmount, formatNu } from '../../utils/formatAmount';
import { Space, Tag, Typography } from 'antd';
import { POSTransaction, POSPaymentDetailRecord } from '../../types/pos';
import { paymentMethodLabel, paymentMethodShortLabel, paymentMethodTagColor } from './SplitPaymentEditor';

const { Text } = Typography;

export function getReceiptPaymentLines(t: POSTransaction): POSPaymentDetailRecord[] {
  if (t.payment_details?.length) {
    return t.payment_details;
  }
  return [
    {
      payment_method: t.payment_method,
      amount: t.total_amount,
      reference_number: t.payment_reference,
      payer_phone: t.payer_phone,
    },
  ];
}

type ReceiptPaymentMethodsProps = {
  transaction: POSTransaction;
  compact?: boolean;
};

export const ReceiptPaymentMethods: React.FC<ReceiptPaymentMethodsProps> = ({
  transaction,
  compact = false,
}) => {
  const lines = getReceiptPaymentLines(transaction);
  const isSplit = lines.length > 1;

  if (compact) {
    return (
      <div className="pos-txn-pay-compact">
        {lines.map((line, idx) => (
          <div key={idx} className="pos-txn-pay-compact-line">
            <Tag color={paymentMethodTagColor(line.payment_method)} style={{ margin: 0 }}>
              {paymentMethodShortLabel(line.payment_method)}
            </Tag>
            {isSplit && (
              <span className="pos-txn-pay-compact-amt app-mono">
                {formatAmount(line.amount)} Nu.
              </span>
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <>
      <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>
        Payment Method{isSplit ? 's' : ''}:
      </Text>
      <Space direction="vertical" size={6} style={{ marginTop: 4, width: '100%' }}>
        {lines.map((line, idx) => (
          <div key={idx} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
            <Tag color={paymentMethodTagColor(line.payment_method)} style={{ margin: 0 }}>
              {paymentMethodShortLabel(line.payment_method)}
            </Tag>
            {isSplit && (
              <Text className="app-mono" style={{ fontSize: '13px', fontWeight: 600 }}>
                {formatNu(line.amount)}
              </Text>
            )}
            {line.reference_number && (
              <Text type="secondary" style={{ fontSize: '11px' }}>
                Jrn: {line.reference_number}
              </Text>
            )}
            {line.payer_phone && (
              <Text type="secondary" style={{ fontSize: '11px' }}>
                Tel: {line.payer_phone}
              </Text>
            )}
          </div>
        ))}
      </Space>
    </>
  );
};
